(function () {
  'use strict';

  // Üst bölüm: kaydırınca gölge
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Mobil menü: kapatma düğmesi, dış alan ve Escape
  document.querySelectorAll('[data-drawer]').forEach(function (drawer) {
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function () { drawer.removeAttribute('open'); });
    });
    drawer.addEventListener('toggle', function () {
      document.documentElement.style.overflow = drawer.open ? 'hidden' : '';
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.open) drawer.removeAttribute('open');
    });
  });

  // Galeri küçük görselleri
  document.querySelectorAll('media-gallery').forEach(function (gallery) {
    gallery.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-thumb]');
      if (!btn) return;
      var id = btn.getAttribute('data-thumb');
      gallery.querySelectorAll('.product__media-item').forEach(function (li) {
        li.classList.toggle('is-active', li.getAttribute('data-media-id') === id);
      });
      gallery.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
    });
  });

  // Adet artır/azalt
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var val = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10));
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Sepette adet değişince kendiliğinden güncelle
  var cartForm = document.getElementById('CartForm');
  if (cartForm) {
    var timer;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty]')) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
        cartForm.appendChild(hidden);
        cartForm.submit();
      }, 600);
    });
  }

  // Koleksiyon sıralama
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Teeinblue dışı ürünlerde seçenekler
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var data = picker.querySelector('[data-variants]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var section = picker.closest('[data-section]');
    var idInput = section && section.querySelector('input[name="id"]');
    var btn = section && section.querySelector('[data-add-btn]');
    picker.addEventListener('change', function () {
      var chosen = Array.prototype.map.call(picker.querySelectorAll('select'), function (s) { return s.value; });
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); });
      if (!match || !idInput) return;
      idInput.value = match.id;
      if (btn) {
        btn.disabled = !match.available;
        btn.querySelector('span').textContent = match.available ? 'Sepete ekle' : 'Tükendi';
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  // Sepet sayacı: Teeinblue ürünü kendi isteğiyle ekliyor, sayacı burada tazele
  function refreshCount() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.header__cart').forEach(function (a) {
        var badge = a.querySelector('.header__count');
        if (!badge && c.item_count > 0) { badge = document.createElement('span'); badge.className = 'header__count'; a.appendChild(badge); }
        if (badge) { badge.textContent = c.item_count; badge.hidden = c.item_count === 0; }
        a.setAttribute('aria-label', 'Sepet, ' + c.item_count + ' ürün');
      });
    }).catch(function () {});
  }
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update)/.test(url)) p.then(function () { setTimeout(refreshCount, 300); });
      return p;
    };
  }
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (/\/cart\/(add|change|update)/.test(url)) this.addEventListener('load', function () { setTimeout(refreshCount, 300); });
    return origOpen.apply(this, arguments);
  };

  // Mobilde alt çubuk: sepet düğmesi görünmüyorken çıkar
  var sticky = document.querySelector('[data-sticky-buy]');
  var addBtn = document.querySelector('[data-add-btn]');
  if (sticky && addBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        // düğme ekranın altında kaldıysa çubuğu göster; görünürse ya da geçildiyse gizle
        sticky.hidden = en.isIntersecting || en.boundingClientRect.top < 0;
      });
    }, { threshold: 0 }).observe(addBtn);
    sticky.querySelector('[data-sticky-go]').addEventListener('click', function () {
      var target = document.querySelector('.product__info-container') || addBtn;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
})();

/* Takım bağlantıları: ?takim=<Teeinblue değer>&sablon=<şablon adı> ile gelen ziyaretçide şablonu ve takımı kendiliğinden seç */
(function () {
  var q = new URLSearchParams(location.search), team = q.get('takim'), tpl = q.get('sablon') || (team ? 'Baba' : '');
  if (!team && !q.get('sablon')) return;
  var t0 = Date.now(), tplDone = false, teamDone = !team;
  function field(re) { return [].find.call(document.querySelectorAll('.tee-field'), function (f) { var h = f.querySelector('.tee-field__heading'); return h && re.test(h.innerText); }); }
  function leaf(root, text) { return [].find.call(root.querySelectorAll('*'), function (e) { return e.children.length === 0 && e.textContent.trim().toLocaleLowerCase('tr') === text.toLocaleLowerCase('tr'); }); }
  (function step() {
    if (Date.now() - t0 > 25000) return;
    if (!tplDone && tpl) {
      var tf = field(/Şablon/i);
      if (tf) { var el = leaf(tf, tpl); if (el) { el.click(); tplDone = true; } }
    } else tplDone = true;
    if (tplDone && !teamDone) {
      var f = field(/Takım Seçin/i), s = f && f.querySelector('select');
      if (s && [].some.call(s.options, function (o) { return o.value === team; })) {
        s.value = team; s.dispatchEvent(new Event('change', { bubbles: true })); teamDone = true;
        setTimeout(function () { var im = f.querySelector('img'); if (im) (im.closest('button, label, [role=button], li, div') || im).click(); }, 1500);
      }
    }
    if (!(tplDone && teamDone)) setTimeout(step, 300);
  })();
})();

/* ürün: teslim tarihi tahmini (iş günü, hafta sonu atlanır) */
(function(){var el=document.querySelector('[data-delivery]'); if(!el)return;
  var AY=['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];
  function add(d,n){d=new Date(d);while(n>0){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)n--;}return d;}
  function f(d){return d.getDate()+' '+AY[d.getMonth()];}
  function isBiz(d){var w=d.getDay();return w!==0&&w!==6;}
  var mn=+el.dataset.min||4,mx=+el.dataset.max||7,cut=+el.dataset.cutoff||16;
  function render(){
    var now=new Date(),c=new Date(now);c.setHours(cut,0,0,0);
    var today=isBiz(now)&&now<c;
    // kesimden sonra ya da hafta sonu: işlem bir sonraki iş günü başlar
    var start=today?now:add(now,1);
    var a=add(start,mn),b=add(start,mx),k=add(start,Math.max(1,mn-1));
    var r=el.querySelector('[data-del-range]'); if(r) r.textContent=(a.getMonth()===b.getMonth()? a.getDate()+'–'+f(b) : f(a)+' – '+f(b))+' arası';
    var d1=el.querySelector('[data-del-d1]'), d2=el.querySelector('[data-del-d2]'); if(d1)d1.textContent=f(k)+' civarı'; if(d2)d2.textContent=f(a)+'–'+b.getDate();
    var d0=el.querySelector('[data-del-d0]'); if(d0) d0.textContent=today?'Bugün':f(start);
    var box=el.querySelector('[data-del-cut]'),t=el.querySelector('[data-del-cut-txt]');
    if(box&&t){
      if(today){var ms=c-now,h=Math.floor(ms/3600000),m=Math.floor(ms%3600000/60000);
        t.innerHTML='<strong>'+(h?h+' sa ':'')+m+' dk</strong> içinde sipariş verirsen hazırlığın <strong>bugün</strong> başlar';}
      else{var tm=new Date(now);tm.setDate(tm.getDate()+1);var GN=['pazar','pazartesi','salı','çarşamba','perşembe','cuma','cumartesi'];
        t.innerHTML='Şimdi sipariş verirsen hazırlığın <strong>'+(start.toDateString()===tm.toDateString()?'yarın sabah':GN[start.getDay()]+' sabah')+'</strong> başlar';}
      box.hidden=false;}
  }
  render(); setInterval(render,30000);
})();

/* sepete eklendi penceresi + birlikte al önerisi */
(function(){var m=document.querySelector('[data-addm]'); if(!m)return;
  var q=new URLSearchParams(location.search), t=q.get('takim');
  if(t) document.querySelectorAll('[data-bundle-link]').forEach(function(a){a.href=a.href+(a.href.indexOf('?')>-1?'&':'?')+'takim='+encodeURIComponent(t);});
  function open(){ if(sessionStorage && sessionStorage.getItem('addm-'+location.pathname)) return; m.hidden=false; document.documentElement.style.overflow='hidden'; document.documentElement.classList.add('addm-open'); try{sessionStorage.setItem('addm-'+location.pathname,'1');}catch(e){} }
  function close(){ m.hidden=true; document.documentElement.style.overflow=''; document.documentElement.classList.remove('addm-open'); }
  m.querySelectorAll('[data-addm-close]').forEach(function(b){b.addEventListener('click',close);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  var of=window.fetch; window.fetch=function(u,o){var p=of.apply(this,arguments); try{var s=typeof u==='string'?u:(u&&u.url)||''; if(/\/cart\/add/.test(s)) p.then(function(r){if(r&&r.ok) setTimeout(open,400);});}catch(e){} return p;};
  var oo=XMLHttpRequest.prototype.open; XMLHttpRequest.prototype.open=function(mt,u){ if(/\/cart\/add/.test(u)) this.addEventListener('load',function(){ if(this.status>=200&&this.status<300) setTimeout(open,400);}); return oo.apply(this,arguments);};
})();

/* ürün: gerçek müşteri sözleri sırayla */
(function(){var b=document.querySelector('[data-pquote]'); if(!b)return; var it=b.querySelectorAll('.pquote__i'), i=0; if(it.length<2)return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  setInterval(function(){it[i].classList.remove('is-on'); i=(i+1)%it.length; it[i].classList.add('is-on');},4200);})();
